import ExportJsonExcel from 'js-export-excel';
import moment from 'moment';
import { useEffect, useState } from "react";
import { Oval } from 'react-loader-spinner';
import fracttalService from "../services/fracttal.service";
import personaService from "../services/persona.service";
import AutoComplete from "./autocomplete.componet";

const Persona = () => {
    const [personas, setPersonas] = useState([]);
    const [persona, setPersona] = useState('');
    const [documentos, setDocumentos] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [cc, setCC] = useState([]);
    const [unidad, setUnidad] = useState('');

    const retreivePersonas = () => {
        setLoading(true);
        personaService.getAll()
            .then(response => {
                console.log(response.data);
                setPersonas(response.data);
                setLoading(false);
            })
            .catch(e => {
                console.error(e);
                setLoading(false);
            });
    };

    function retreiveCC() {
        personaService.getCC()
            .then(resp => {
                setCC(resp.data)
            })
            .catch(err => {
                console.error(err);
            });
    }

    useEffect(() => {
        retreivePersonas();
        retreiveCC();
    }, []);

    const buscarPersona = () => {
        setLoading(true);
        const valor = document.getElementById("autocompletar");
        const r = valor.value.split(' - ');
        const rut2 = r[1];
        //Buscamos a la persona en la BD de UnySoft
        personaService.getPorRut(rut2)
            .then(persona => {
                setPersona(persona.data[0]);
            });

        //Buscamos los documentos de la persona en Fracttal
        //console.log(rut2.replace(/\./g, ''));
        const data = {
            rut: rut2.replace(/\./g, '')
        };
        fracttalService.getDocumentos(data)
            .then(f => {
                setDocumentos(f.data);
                setLoading(false);
            });
    }

    const exceXunidad = () => {
        var cols = [];
        if (unidad !== "") {
            var pers = personas.filter(v => v.ctoDescripcion === unidad);
            var pers_activo = pers.filter(v => v.estado === true);
            for (var i in pers_activo) {
                let obj = {
                    rut: pers_activo[i].Rut,
                    ap_paterno: pers_activo[i].perApPaterno,
                    ap_materno: pers_activo[i].perApMaterno,
                    nombre_1: pers_activo[i].perNombre1,
                    nombre_2: pers_activo[i].perNombre2,
                    sexo: pers_activo[i].perSexo,
                    unidad: pers_activo[i].ctoDescripcion,
                    fono: pers_activo[i].perFax,
                    correo: pers_activo[i].perCorreo,
                    nacionalidad: pers_activo[i].perNacionalidad,
                    ciudad: pers_activo[i].paisComunaDescripcion,
                    cargo: pers_activo[i].recDescripcion,
                    fecha_contrato: moment(pers_activo[i].FechaContrato).utc().format("DD/MM/YYYY"),
                    fecha_contrato_inicial: moment(pers_activo[i].FechaContratoInicial).utc().format("DD/MM/YYYY"),
                    fecha_nacimiento: moment(pers_activo[i].perFechaNac).utc().format("DD/MM/YYYY")//(moment(pers_activo[i].perFechaNac).unix())/86400 + 25569,
                }
                cols.push(obj);
            }
            let option = {};
            option.fileName = "DATARRHH";
            option.datas = [
                {
                    sheetData: cols,
                    sheetName: "RRHH",
                    sheetHeader: ['Rut', 'AP PATERNO', 'AP MATERNO', 'PRIMER NOMBRE', 'SEGUNDO NOMBRE', 'SEXO', 'UNIDAD', 'TELEFONO', 'CORREO', 'NACIONALIDAD', 'CIUDAD', 'CARGO', 'FECHA CONTRATO', 'FECHA CONTRATO INICAL', 'FECHA NACIMIENTO',]
                }
            ];
            let toExcel = new ExportJsonExcel(option);
            toExcel.saveExcel();
        }
    }

    const execlTodo = () => {
        var cols = [];
        let option = {};
        var pers_activo = personas.filter(v => v.estado === true);
        for (var i in pers_activo) {
            let obj = {
                rut: pers_activo[i].Rut,
                ap_paterno: pers_activo[i].perApPaterno,
                ap_materno: pers_activo[i].perApMaterno,
                nombre_1: pers_activo[i].perNombre1,
                nombre_2: pers_activo[i].perNombre2,
                sexo: pers_activo[i].perSexo,
                unidad: pers_activo[i].ctoDescripcion,
                fono: pers_activo[i].perFax,
                correo: pers_activo[i].perCorreo,
                nacionalidad: pers_activo[i].perNacionalidad,
                ciudad: pers_activo[i].paisComunaDescripcion,
                cargo: pers_activo[i].recDescripcion,
                fecha_contrato: moment(pers_activo[i].FechaContrato).utc().format("DD/MM/YYYY"),
                fecha_contrato_inicial: moment(pers_activo[i].FechaContratoInicial).utc().format("DD/MM/YYYY"),
                fecha_nacimiento: moment(pers_activo[i].perFechaNac).utc().format("DD/MM/YYYY"),
            }
            cols.push(obj);
        }
        option.fileName = "DATARRHH";
        option.datas = [
            {
                sheetData: cols,
                sheetName: "RRHH",
                sheetHeader: ['Rut', 'AP PATERNO', 'AP MATERNO', 'PRIMER NOMBRE', 'SEGUNDO NOMBRE', 'SEXO', 'UNIDAD', 'TELEFONO', 'CORREO', 'NACIONALIDAD', 'CIUDAD', 'CARGO', 'FECHA CONTRATO', 'FECHA CONTRATO INICAL', 'FECHA NACIMIENTO',]
            }
        ];
        let toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
    }

    return isLoading ? (
        <div>
            <div className="d-flex justify-content-center">
                <Oval
                    heigth="100"
                    width="100"
                    color='blue'
                    ariaLabel='loading'
                />
            </div>
            <p className="text-center">Cargando ...</p>
        </div>
    ) : (
        <div>
            <div className="row">
                <div className="col-12">
                    <div className="col-md-12 p-3">
                        <div className="text-center">
                            <h2>Descarga de Personal</h2>
                        </div>
                        <div className="hstack gap-3">
                            <select className="form-select" aria-label="Default select example" onChange={(e) => setUnidad(e.target.value)}>
                                <option selected value="">Seleccione Unidad...</option>
                                {cc.map((item, index) => {
                                    return (
                                        <option key={index} value={item.ctoDescripcion}>{item.ctoDescripcion}</option>
                                    )
                                })}
                            </select>
                            <button type="button" className="btn btn-secondary" onClick={exceXunidad}>Descargar por Unidad</button>
                            <div className="vr"></div>
                            <button type="button" className="btn btn-outline-danger" onClick={execlTodo}>Descargar todo</button>
                        </div>
                    </div>
                    <div className="text-center">
                        <h2>Datos de Trabajador</h2>
                    </div>
                    <div className="row p-3">
                        <div className="col-md-8">
                            <AutoComplete suggestions={personas.map(({ perApMaterno, perNombre1, perApPaterno, Rut }) => perNombre1 + " " + perApPaterno + " " + perApMaterno + " - " + Rut)} />
                            <div id="rutHelp" className="form-text">Ingresar nombre o Rut (con puntos y guion)</div>
                        </div>
                        <div className="col-md-4">
                            <button className="btn btn-primary" onClick={buscarPersona}>Buscar</button>
                        </div>
                    </div>
                    <table className="table">
                        <tr>
                            <td>Rut:</td>
                            <td>{persona.Rut}</td>
                        </tr>
                        <tr>
                            <td>Nombre</td>
                            <td>{persona ? persona.perNombre1 + " " + persona.perNombre2 + " " + persona.perApPaterno + " " + persona.perApMaterno : ""}</td>
                        </tr>
                        <tr>
                            <td>Unidad de Negocio:</td>
                            <td>{persona.ctoDescripcion}</td>
                        </tr>
                        <tr>
                            <td>Cargo:</td>
                            <td>{persona.recDescripcion}</td>
                        </tr>
                        <tr>
                            <td>Fecha Ingreso:</td>
                            <td>{persona ? moment(persona.FechaContratoInicial).local().format('DD/MM/YYYY') : ""}</td>
                        </tr>
                        <tr>
                            <td>Estado:</td>
                            <td>{persona.estado == true ? "Activo" : "Inactivo"}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="text-center">
                        <h2>Documentos Trabajador</h2>
                    </div>
                    <table className="table">
                        <tr>
                            <th>Nombre Documento</th>
                            <th>Valido desde</th>
                            <th>Valido hasta</th>
                        </tr>
                        {documentos ? documentos.map(d => {
                            var ds = d.name.split('-');
                            if (d.valid_from !== null) {
                                return (
                                    <tr>
                                        <td>{ds[0]}</td>
                                        <td>{moment(d.valid_from).local().format('DD/MM/YYYY')}</td>
                                        <td>{moment(d.valid_through).local().format('DD/MM/YYYY')}</td>
                                    </tr>
                                )
                            }
                        }) : ""}
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Persona;